import { useEffect, useState } from 'react';
import api from '../utils/api';

/**
 * Componente que actualiza dinámicamente el título y favicon del navegador
 * basado en la configuración general de la plataforma.
 */
const DynamicHead = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const loadConfiguration = async () => {
      try {
        const response = await api.get('/configuracion/general');
        const config = response.data;

        // Actualizar título del navegador
        if (config.platform_name) {
          document.title = config.platform_name;
        }

        // Actualizar favicon
        if (config.logo_url) {
          updateFavicon(config.logo_url);
        }

        setLoaded(true);
      } catch (error) {
        console.error('Error loading configuration for head:', error);
        // Mantener título por defecto si hay error
        document.title = 'Postventa Imagina';
      }
    };

    loadConfiguration();
  }, []);

  /**
   * Actualiza el favicon del navegador
   * @param {string} logoUrl - URL de la imagen del logo
   */
  const updateFavicon = (logoUrl) => {
    try {
      // Buscar favicon existente
      let favicon = document.querySelector("link[rel='icon']");
      
      if (!favicon) {
        // Crear elemento si no existe
        favicon = document.createElement('link');
        favicon.rel = 'icon';
        document.head.appendChild(favicon);
      }

      // Actualizar href con la URL del logo
      favicon.href = logoUrl;

      // También actualizar apple-touch-icon si existe
      let appleTouchIcon = document.querySelector("link[rel='apple-touch-icon']");
      if (!appleTouchIcon) {
        appleTouchIcon = document.createElement('link');
        appleTouchIcon.rel = 'apple-touch-icon';
        document.head.appendChild(appleTouchIcon);
      }
      appleTouchIcon.href = logoUrl;

    } catch (error) {
      console.error('Error updating favicon:', error);
    }
  };

  // Este componente no renderiza nada visible
  return null;
};

export default DynamicHead;
